import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

const BITACORAIFCHANGEPRIORIZATION = 'prioritized_order';
@Component({
  selector: 'app-prioritize-products',
  templateUrl: './prioritize-products.component.html',
  styleUrls: ['./prioritize-products.component.scss'],
})
export class PrioritizeProductsComponent implements OnInit {

  select_products: any[] = [];
  formGroup: FormGroup;
  statusValidation = false;
  back = '';

  constructor(
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    public copyService: CopyService,
    private headerService: HeaderService,
    private formBuilder: FormBuilder,
    private taggingService: TaggingService,
    private bitacoraService: BitacoraService,
  ) {
    this.headerService.show(true, true, true);
  }

  ngOnInit() {
    // TODO: SETEO DE DATOS
    this.abreCuentasService.setProspectResponse({ client: false });
    this.select_products = this.abreCuentasService.getProductsSelects();
    this.formGroup = this.formBuilder.group(this.createForm());
    this.validateDulicate(this.formGroup.value);
    this.formGroup.valueChanges.subscribe(res => {
      this.validateDulicate(res);
    });
  }

  /**
   * @returns crear validaciones para productos seleccionados
   */
  createForm() {
    let values: any = {};
    let index = 0;
    for (let field of this.select_products) {
      values[index] = [field.flow];
      values[index].push(Validators.required);
      index++;
    }
    return values;
  }

  /**
   * @param object objeto resultante de formulario
   */
  validateDulicate(object: any) {
    this.statusValidation = false;
    let array: any[] = [];
    let count = 0;

    for (let row in object) {
      count++;
      if (object[row] !== '') {
        if (array.indexOf(object[row]) !== (-1)) {
          this.statusValidation = true;
        }
        array.push(object[row]);
      }
    }
  }

  /**
   * avanzar al siguiente paso
   */
  next() {
    const sendExtras = {
      object: 'transactionProductDetails',
      value: this.addProductExtra(),
      pageValue: 'prioritize-products',
    };
    this.sendTagging('next', 'bottom', '3', sendExtras);
    this.validateIfNewPrioritize();
  }

  sendTagging(value: any, position?: string, event?: string, extras?: any) {
    const page = '31';
    this.taggingService.sendTaggValues(value, page, position, event, extras);
  }

  addProductExtra() {
    let extras = '';
    this.select_products.forEach((product, index) => {
      switch (product.product_code) {
        case 'TCR':
          extras += 'TarjetaCredito';
          break;
        case 'ORD':
          extras += 'CreditoPersonal';
          break;
        case 'CRP':
          extras += 'CreditoRotativo';
          break;
      }
      if (index < (this.select_products.length - 1)) {
        extras += ',';
      }
    });
    return extras;
  }
  validateIfNewPrioritize() {
    let callBitacora = false;
    for (let index in this.formGroup.value) {
      this.select_products.map(
        product => {
          if (product.flow === this.formGroup.value[index]) {
            product.prioritizeForClient = (+index + 1);
            if (!this.abreCuentasService.getPriorization()) {
              if (`${product.prioritizeForClient}` !== product.prioritize) {
                callBitacora = true;
                this.abreCuentasService.setPriorization(true);
              }
            }
          }
          return product;
        },
      );
    }
    if (callBitacora) {
      console.log(BITACORAIFCHANGEPRIORIZATION);
      this.bitacoraService.saveDataInBitacora(BITACORAIFCHANGEPRIORIZATION);
    }
    this.abreCuentasService.setProductsSelects(this.select_products);
    console.log('-----', this.abreCuentasService.getProductsSelects());
    this.navigationService.nextStep('200');
  }

}
